module.exports = __webpack_public_path__ + "static/media/icofont.4abc402d.woff";